import { useId, useState } from 'react';
import DataTable from '../DataTable/DataTable';
import './DataSourceTables.css';

export interface TableSample {
    table: string;
    columns: string[];
    rows: unknown[][];
}

export default function DataSourceTables({ samples }: { samples: TableSample[] }) {
    const [selectedIndex, setSelectedIndex] = useState(0);
    const id = useId();
    const activeIndex = selectedIndex < samples.length ? selectedIndex : 0;
    const sample = samples[activeIndex];

    if (!sample) {
        return <p className="text-[14px] text-[#71717a] m-0">No data source information available for this result.</p>;
    }

    return (
        <div className="methodology-data-sources flex flex-col gap-4 w-full min-w-0">
            <div role="tablist" aria-label="Source tables" className="flex gap-1 self-start max-w-full overflow-x-auto bg-[#f4f4f5] rounded-md p-1">
                {samples.map((entry, index) => (
                    <button
                        key={`${entry.table}-${index}`}
                        id={`${id}-tab-${index}`}
                        role="tab"
                        type="button"
                        aria-selected={index === activeIndex}
                        aria-controls={`${id}-panel`}
                        tabIndex={index === activeIndex ? 0 : -1}
                        onClick={() => setSelectedIndex(index)}
                        onKeyDown={(event) => {
                            const next = event.key === 'ArrowRight' ? (index + 1) % samples.length
                                : event.key === 'ArrowLeft' ? (index - 1 + samples.length) % samples.length
                                : event.key === 'Home' ? 0 : event.key === 'End' ? samples.length - 1 : undefined;
                            if (next === undefined) return;
                            event.preventDefault();
                            setSelectedIndex(next);
                            document.getElementById(`${id}-tab-${next}`)?.focus();
                        }}
                        className={`border-none rounded px-3 py-1 text-[14px] whitespace-nowrap cursor-pointer ${index === activeIndex ? 'bg-white text-[#1f1f1f] shadow-sm' : 'bg-transparent text-[#71717a]'}`}
                    >
                        {entry.table}
                    </button>
                ))}
            </div>
            <div id={`${id}-panel`} role="tabpanel" aria-labelledby={`${id}-tab-${activeIndex}`} className="w-full min-w-0">
                <DataTable
                    key={`${activeIndex}-${sample.table}`}
                    vizData={{ data: [sample.columns, ...sample.rows] }}
                    maxWidth="100%"
                    scroll={{ x: 'max-content' }}
                    pagination={{ pageSize: 5, showSizeChanger: false, hideOnSinglePage: true, position: ['bottomCenter'] }}
                />
            </div>
        </div>
    );
}
